export enum AdminPanelRoutes {
	Organizations = 'organizations',
	Accounts = 'accounts',
	Users = 'users',
	Partners = 'partners',
	Reports = 'reports',
	ApproveBilling = 'approve-billing',
	Permissions = 'permissions',
}
